import React from 'react';
import { Helmet } from "react-helmet";
import Layout from '../../components/Layout';
import { Formik, Form } from 'formik';
import API from '../../functions/api';
import { validate, defaultSchema } from '../../functions/validation';
import { request } from '../../functions/apiRequestHelper';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import queryString from 'query-string';
import _find from 'lodash/find';
import Button from '../../audi-ui-components/Button';
import TextField from '../../audi-ui-components/TextField';
import TextArea from '../../audi-ui-components/TextArea';
import Dropdown from '../../audi-ui-components/Dropdown';
import Select from '../../audi-ui-components/Select';
import Checkbox from '../../audi-ui-components/Checkbox';
import RadioFieldset from '../../audi-ui-components/RadioFieldset';
import Spinner from '../../audi-ui-components/Spinner';
import AFSDisclaimer from './AFSDisclaimer';
import MaintenanceMessage from '../../components/MaintenanceMessage';
import {
    UI_AUDI,
    PATH_AFS_ENQUIRY,
    PATH_THANKS,
    MAINTENANCE_SF,
    DEFAULT_THEME
} from '../../constants';
import {
    CUSTOMER_NEW,
    CUSTOMER_EXISTING,
    CONTACT_PHONE,
    CONTACT_EMAIL,
    ENQUIRY_DESC_2_DAYS,
    ENQUIRY_DESC_3_HOURS,
    REQUEST_TYPES,
    OPTS_NEW,
    OPTS_EX_PHONE,
    OPTS_EX_EMAIL,
    OPTS_EX_EMAIL_SUB
} from './enquiryConst';

const validationSchema = {
    firstName: defaultSchema.firstName,
    lastName: defaultSchema.lastName,
    emailAddress: defaultSchema.emailAddress,
    phoneNumber: defaultSchema.phoneNumber,
    postCode: defaultSchema.postCode,
    customerType: {
        presence: {message: "Please choose a customer type", allowEmpty: false}
    },
    enquirySelect: {
        presence: {message: "Please choose an enquiry type", allowEmpty: false}
    },
    termsAndConditions: {
        truthy: {message: "You must agree to the Terms &amp; Conditions and Privacy Policy"}
    },
    locationId: function(value, attributes, attributeName, options, constraints) {
        if (attributes.customerType === CUSTOMER_NEW) {
            return {
                presence: {message: "Please select a dealer", allowEmpty: false}
            };
        }
        return;
    },
    registrationNumber: function(value, attributes, attributeName, options, constraints) {
        if (attributes.customerType === CUSTOMER_EXISTING) {
            return {
                presence: {message: "Please enter your registration number", allowEmpty: false}
            };
        }
        return;
    },
    contractNumber: function(value, attributes, attributeName, options, constraints) {
        if (attributes.customerType === CUSTOMER_EXISTING) {
            return {
                presence: {message: "Please enter your contract number", allowEmpty: false}
            };
        }
        return;
    }
};

const initialValues = {
    customerType: "",
    contactType: CONTACT_EMAIL,
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    postCode: "",
    contractNumber: "",
    registrationNumber: "",
    enquirySelect: "",
    emailEnquirySelect: "",
    comment: "",
    termsAndConditions: false,
    // findDealerBy: "postcode"
};

class AFSEnquiry extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dealerData: [],
            isLoadingDealers: true,
            submitted: false,
            submitting: false,
            submittedData: {}
        }
    }

    componentDidMount() {
        gtmPageview(PATH_AFS_ENQUIRY);
        API.post(
          `${process.env.RAZZLE_GQLAPI}`,
          {
              query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: LocationDtoSortInput!, $filter: LocationDtoFilterInput) {
                locationList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
                  items {
                    id
                    name
                    suburb
                    postcode
                    state
                    dealer {
                      dealerCode
                      dealerId
                      status
                      name
                    }
                  }
                }
              }`,
              variables: {
                skip: 0,
                take: 50,
                sort: {state: "ASC", name: "ASC"},
                filter: {type: {eq: "Sales"}, status: {eq: true}}
              }
          }
        ).then(response => {
            // console.log(response);
            let items = response.data?.data?.locationList?.items || [];
            this.setState({dealerData: items, isLoadingDealers: false});
        }).catch(() => {
            this.setState({isLoadingDealers: false});
        });
    }

    handleSubmit = (_values, formikBag) => {
        this.setState({serverError: null});
        let {locationId, ...values} = _values;
        let loc = _find(this.state.dealerData, {id: locationId});
        if (loc) {
          values.dealerName = loc.dealer.name;
          values.dealerId = loc.dealer.dealerId;
        }
        if (values.hasOwnProperty("optIn")) {
            if (values.optIn === "") {
                values.optIn === false;
            }
            values.optOut = !values.optIn;
        }
        if (process.env.RAZZLE_APP_ENV !== "local" || values.submitToBackend) {
            // submit to backend
            // thneed.trigger(thneed.events.formSubmit, "afs-enquiry", {formData: values, formName: "afs-enquiry"});
            gtmPush("form", "formSubmit", "afs-enquiry", values);
            return request(`${process.env.RAZZLE_API_HOST}/1/form`, {
                    method: "POST",
                    body: JSON.stringify({
                        formName: "afs-enquiry",
                        payload: values,
                        variation: 1,
                    })
                }
            ).then((result) => { // SUCCESS
                // thneed.trigger(thneed.events.formSubmitSuccess, "afs-enquiry", {formData: values, formName: "afs-enquiry"});
                gtmPush("form", "formSubmitSuccess", "afs-enquiry", values);
                this.setState({submitted: true, submittedData: values});
                // this.props.history.push(`${PATH_AFS_ENQUIRY}${PATH_THANKS}`);
                gtmPageview(`${PATH_AFS_ENQUIRY}${PATH_THANKS}`);
            }).catch((error) => { // FAIL
                console.error(error);
                // thneed.trigger(thneed.events.formSubmitError, "afs-enquiry", {formData: values, formName: "afs-enquiry"});
                gtmPush("form", "formSubmitError", "afs-enquiry", values);
                formikBag.setSubmitting(false);
                if (error.body) {
                    if (error.body.modelState) {
                        let errors = {};
                        for (let key in error.body.modelState) {
                            if (!Object.hasOwnProperty(key)) {
                                errors[key] = error.body.modelState[key][0];
                            }
                        }
                        formikBag.setErrors(errors);
                    } else if (error.body.message) {
                        this.setState({serverError: error.body.message});
                    }
                }
            });
        } else {
            // fake submit for frontend testing
            console.log(values);
            this.setState({submitting: false, submitted: true, submittedData: values});
            // this.props.history.push(`${PATH_AFS_ENQUIRY}${PATH_THANKS}`);
        }
    }

    validateForm = (values) => {
        let v = validate(values, validationSchema, {format: "firstError", fullMessages: false});
        // console.log("[validate]", values, v);
        return v;
    }

    getEnquiryTypeOpts = (customerType, contactType) => {
        if (customerType === CUSTOMER_NEW) {
            return OPTS_NEW;
        }
        if (contactType === CONTACT_EMAIL) {
            return OPTS_EX_EMAIL;
        }
        return OPTS_EX_PHONE;
    }

    getEnquiryTypeDesc = (enquirySelect, customerType) => {
        if (customerType === CUSTOMER_NEW || !enquirySelect || enquirySelect === "") {
            return null;
        }
        if (
            enquirySelect === REQUEST_TYPES.PHONE_REQUEST_DOCUMENTS ||
            enquirySelect === REQUEST_TYPES.PHONE_UPDATE_INFORMATION ||
            enquirySelect === REQUEST_TYPES.PHONE_CURRENT_BALANCE ||
            enquirySelect === REQUEST_TYPES.OTHER
        ) {
            return ENQUIRY_DESC_3_HOURS;
        }
        return ENQUIRY_DESC_2_DAYS;
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const {submitted, submittedData} = this.state;
        return (
            <Layout ui={query.ui ? query.ui : UI_AUDI} embedded={query.embedded} theme={theme}>
                <Helmet>
                    <title>Enquiry | Audi Financial Services</title>
                </Helmet>

                <main className="audi-forms__page">

                    {submitted && submittedData.contactType !== CONTACT_PHONE && <div className="pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Thank you for your enquiry.</h1>
                        <p className="mb-3">Your enquiry has been submitted and you will receive an email confirmation shortly.</p>
                    </div>}
                    {submitted && submittedData.contactType === CONTACT_PHONE && <div className="pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Thank you. Please keep your phone handy.</h1>
                        <p className="mb-3">An Audi Financial Services Representative will call you within the next 1-2 business hours to discuss your enquiry.</p>
                    </div>}

                    {!submitted && <div className="pt-3 pt-medium-5">
                        <Formik onSubmit={this.handleSubmit} initialValues={initialValues} validate={this.validateForm}>
                            {({values, errors, touched, setFieldValue, setValues, setFieldTouched, isSubmitting}) => (
                                <Form className="audi-form">
                                    {isSubmitting && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                                    {MAINTENANCE_SF && <MaintenanceMessage opts={[
                                        <>Call us on <a className="aui-textlink" href="tel:1300734567">1300 734 567</a>, between 9am – 5pm (AEST), Monday – Friday.</>
                                    ]} />}

                                    <RadioFieldset name="customerType"
                                        title="Are you a new customer?"
                                        options={[
                                            {label: CUSTOMER_NEW, value: CUSTOMER_NEW},
                                            {label: CUSTOMER_EXISTING, value: CUSTOMER_EXISTING}
                                        ]}
                                        value={values.customerType}
                                        onChange={(v) => { setValues({...values, customerType: v, enquirySelect: ""}); }}
                                        onBlur={() => { setFieldTouched('customerType'); }}
                                        isInvalid={errors.customerType && touched.customerType}
                                        invalidMessage={errors.customerType}
                                        theme={theme === "dark" ? "light" : null}
                                        className="form-field"
                                    />

                                    <div style={{display: values.customerType === CUSTOMER_EXISTING ? 'block' : 'none'}}>
                                        <RadioFieldset name="contactType"
                                            title="I would prefer to be contacted by"
                                            options={[
                                                {label: "Email", value: CONTACT_EMAIL},
                                                {label: "Phone", value: CONTACT_PHONE}
                                            ]}
                                            value={values.contactType}
                                            onChange={(v) => { setValues({...values, contactType: v, enquirySelect: ""}); }}
                                            theme={theme === "dark" ? "light" : null}
                                            className="form-field"
                                        />
                                    </div>

                                    <div style={{display: (values.customerType === CUSTOMER_EXISTING && values.contactType) || values.customerType === CUSTOMER_NEW ? 'block' : 'none'}}>
                                        <TextField name="firstName"
                                            label="First name"
                                            value={values.firstName}
                                            onChange={(v) => { setFieldValue('firstName', v); }}
                                            isInvalid={errors.firstName && touched.firstName}
                                            invalidMessage={errors.firstName}
                                            onBlur={() => { setFieldTouched('firstName'); }}
                                            theme={theme === "dark" ? "light" : null}
                                            className="form-field"
                                        />
                                        <TextField name="lastName"
                                            label="Last name"
                                            value={values.lastName}
                                            onChange={(v) => { setFieldValue('lastName', v); }}
                                            isInvalid={errors.lastName && touched.lastName}
                                            invalidMessage={errors.lastName}
                                            onBlur={() => { setFieldTouched('lastName'); }}
                                            theme={theme === "dark" ? "light" : null}
                                            className="form-field"
                                        />
                                        <TextField name="emailAddress"
                                            label="Email"
                                            value={values.emailAddress}
                                            onChange={(v) => { setFieldValue('emailAddress', v.trim()); }}
                                            isInvalid={errors.emailAddress && touched.emailAddress}
                                            invalidMessage={errors.emailAddress}
                                            onBlur={() => { setFieldTouched('emailAddress'); }}
                                            theme={theme === "dark" ? "light" : null}
                                            className="form-field"
                                        />
                                        <TextField name="phoneNumber"
                                            label="Phone number"
                                            value={values.phoneNumber}
                                            onChange={(v) => { setFieldValue('phoneNumber', v); }}
                                            isInvalid={errors.phoneNumber && touched.phoneNumber}
                                            invalidMessage={errors.phoneNumber}
                                            onBlur={() => { setFieldTouched('phoneNumber'); }}
                                            theme={theme === "dark" ? "light" : null}
                                            className="form-field"
                                        />
                                        <TextField name="postCode"
                                            label="Postcode"
                                            value={values.postCode}
                                            onChange={(v) => { setFieldValue('postCode', v.trim()); }}
                                            isInvalid={errors.postCode && touched.postCode}
                                            invalidMessage={errors.postCode}
                                            onBlur={() => { setFieldTouched('postCode'); }}
                                            theme={theme === "dark" ? "light" : null}
                                            className="form-field"
                                        />

                                        <div style={{display: values.customerType === CUSTOMER_NEW ? 'block' : 'none'}}>
                                            <Select name="locationId"
                                                label="Select a dealer*"
                                                value={values.locationId}
                                                options={this.state.dealerData.map(loc => { return {label: `${loc.dealer.name} (${loc.state} ${loc.postcode})`, value: loc.id} })}
                                                onChange={(v) => { setFieldValue('locationId', v); }}
                                                onBlur={() => { setFieldTouched('locationId'); }}
                                                isInvalid={errors.locationId && touched.locationId}
                                                invalidMessage={errors.locationId}
                                                theme={theme === "dark" ? "light" : null}
                                                className="form-field"
                                                description={this.state.isLoadingDealers ? "Loading dealers..." : ""}
                                            />
                                        </div>

                                        <div style={{display: values.customerType === CUSTOMER_EXISTING ? 'block' : 'none'}}>
                                            <TextField name="contractNumber"
                                                label="Contract number"
                                                value={values.contractNumber}
                                                onChange={(v) => { setFieldValue('contractNumber', v.substring(0,15)); }}
                                                onBlur={() => { setFieldTouched('contractNumber'); }}
                                                isInvalid={errors.contractNumber && touched.contractNumber}
                                                invalidMessage={errors.contractNumber}
                                                theme={theme === "dark" ? "light" : null}
                                                className="form-field"
                                            />
                                            <TextField name="registrationNumber"
                                                label="Vehicle registration number"
                                                value={values.registrationNumber}
                                                onChange={(v) => { setFieldValue('registrationNumber', v.toUpperCase()); }}
                                                onBlur={() => { setFieldTouched('registrationNumber'); }}
                                                isInvalid={errors.registrationNumber && touched.registrationNumber}
                                                invalidMessage={errors.registrationNumber}
                                                maxLength={20}
                                                theme={theme === "dark" ? "light" : null}
                                                className="form-field"
                                            />
                                        </div>

                                        <div className="row">
                                            <div className="col-12 col-small-6">
                                                <Select name="enquirySelect"
                                                    label="Enquiry type"
                                                    value={values.enquirySelect}
                                                    options={this.getEnquiryTypeOpts(values.customerType, values.contactType)}
                                                    onChange={(v) => { setValues({...values, enquirySelect: v, emailEnquirySelect: ""}); }}
                                                    onBlur={() => { setFieldTouched('enquirySelect'); }}
                                                    isInvalid={errors.enquirySelect && touched.enquirySelect}
                                                    invalidMessage={errors.enquirySelect}
                                                    theme={theme === "dark" ? "light" : null}
                                                    className="form-field"
                                                />
                                            </div>
                                            {OPTS_EX_EMAIL_SUB.hasOwnProperty(values.enquirySelect) && <div className="col-12 col-small-6">
                                                <Select name="emailEnquirySelect"
                                                    label="Enquiry type"
                                                    value={values.emailEnquirySelect}
                                                    options={OPTS_EX_EMAIL_SUB[values.enquirySelect]}
                                                    onChange={(v) => { setFieldValue('emailEnquirySelect', v); }}
                                                    onBlur={() => { setFieldTouched('emailEnquirySelect'); }}
                                                    isInvalid={errors.emailEnquirySelect && touched.emailEnquirySelect}
                                                    invalidMessage={errors.emailEnquirySelect}                                                    theme={theme === "dark" ? "light" : null}                                                    className="form-field"
                                                />
                                            </div>}
                                        </div>

                                        <p className="mb-3">
                                            {this.getEnquiryTypeDesc(values.enquirySelect, values.customerType)}
                                        </p>

                                        <div style={{display: values.enquirySelect ? 'block' : 'none'}}>
                                            <TextArea name="comment"
                                                label="Please expand on your query below"
                                                value={values.comment}
                                                onChange={(v) => { setFieldValue('comment', v); }}
                                                theme={theme === "dark" ? "light" : null}
                                                className="form-field"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <Checkbox name="optIn"
                                                label="I would like to hear more about Audi Financial Services Offers."
                                                checked={!!values.optIn}
                                                value=""
                                                onChange={(v,e) => { setFieldValue('optIn', e.target.checked); }}
                                                theme={theme === "dark" ? "light" : null}
                                                className="form-field"
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Checkbox name="termsAndConditions"
                                                label="Consent of Terms & Conditions and Privacy Policy."
                                                checked={!!values.termsAndConditions}
                                                value=""
                                                onChange={(v,e) => { setFieldValue('termsAndConditions', e.target.checked); }}
                                                onBlur={() => { setFieldTouched('termsAndConditions'); }}
                                                isInvalid={errors.termsAndConditions && touched.termsAndConditions}
                                                invalidMessage={errors.termsAndConditions}
                                                theme={theme === "dark" ? "light" : null}
                                                className="form-field"
                                            />
                                        </div>
                                    </div>

                                    {process.env.RAZZLE_APP_ENV === 'local' && <div className="form-field dev-only">
                                        <Checkbox name="submitToBackend" label="Submit to backend" checked={!!values.submitToBackend} value="" onChange={(v,e) => { setFieldValue('submitToBackend', e.target.checked); }} />
                                    </div>}

                                    <div className="form-field submit">
                                        {this.state.serverError && <p className="aui-color-text-red submit-error">{this.state.serverError}</p>}
                                        <Button label="Submit" type="submit" buttonType="primary" theme={theme === "dark" ? "light" : null} className="red" />
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <AFSDisclaimer />
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default AFSEnquiry;
